import { useTerminalsState } from "@/States/Terminals";
import { useCommonEntitiesStore } from "@/States/commonEntities";
import { trpc } from "@/Utils/trpc";

import { useMemo } from "react";

import { uniq } from "lodash";

export const useMinimalCustomers = () => {
  const { currentTerminal } = useTerminalsState();
  const { tenantCategories } = useCommonEntitiesStore();

  const {
    data: minimalCustomerList = [],
    isLoading: isLoadingMinimalCustomers,
    refetch: refetchMinimalCustomers,
  } = trpc.customers.getAllMinimal.useQuery({
    terminalId: currentTerminal?.id || undefined,
  });

  const usedTenantCategories = useMemo(() => {
    const usedCategories = uniq(minimalCustomerList.map((c) => c.categoryId));

    return tenantCategories?.filter((c) => usedCategories.includes(c.id));
  }, [minimalCustomerList, tenantCategories]);

  return {
    minimalCustomerList,
    isLoadingMinimalCustomers,
    refetchMinimalCustomers,
    usedTenantCategories,
  };
};
